import { Grid, Modal, Textarea } from '@mantine/core';
import { IAuditLog } from '../../../../libraries/helpdesk/audit-logs';
import ModalComponent from '../../../components/modal';
import { Language } from '../../../languages/languageHandler';
import { getAuditTypeDescription } from '../../utils';

interface ShowAuditLogProps {
  log: IAuditLog;
  openDetails: boolean;
  hideBtn: VoidFunction;
  lang: Language;
}

const ShowAuditLog = ({ log, openDetails, hideBtn, lang }: ShowAuditLogProps) => {
  return (
    <>
      <ModalComponent
        show={openDetails}
        handleClick={hideBtn}
        title={`#${log.seqid} - ${log.atype} - ${getAuditTypeDescription(log.atype, lang)}`}
        content={
          <Modal.Body>
            <Grid>
              <Grid.Col span={6}>
                <Textarea label={lang.GLOBAL_BEFORE} value={log.beforedata || ''} disabled autosize />
              </Grid.Col>
              <Grid.Col span={6}>
                <Textarea label={lang.GLOBAL_AFTER} value={log.afterdata || ''} disabled autosize />
              </Grid.Col>
            </Grid>
          </Modal.Body>
        }
      />
    </>
  );
};

export default ShowAuditLog;
